import { AuthMessageType, ClientType, ConnectionMessage, ConnectionMessageType, websocket } from '@playcastdotio/Messaging';
import { getPersistentPlayerId } from '../../..';
import { authStore, joinState } from '../../../stores/globalStores';
import { profileState } from '../../../stores/lobbyStores';
import { playerConnectionState } from '../../../stores/playerStores';
import { setIsReady, setFastStartInvitationId } from '..';

// Flag to track if auth is pending (disabled for marketing-demo)
// let isAuthPending = false;

// Function to be called when AUTH_SUCCESS is received
export const onAuthSuccess = (): boolean => {
  // isAuthPending = false;

  // AUTH_UPGRADE disabled for marketing-demo to prevent lag at start
  // Instead, JWT token is passed in message payloads when needed (e.g., wishlist email)
  // Check if we have a token now that needs to be upgraded
  const token = authStore.currentState.accessToken;
  if (token && window.pendingAuthUpgradeSocket) {
    // const upgradeMsg = websocket.generators.auth(AuthMessageType.AUTH_UPGRADE, {
    //   clientType: ClientType.PLAYER,
    //   persistentId: getPersistentPlayerId(),
    //   tokenJwt: token,
    // });
    // window.pendingAuthUpgradeSocket.send(JSON.stringify(upgradeMsg));
    window.pendingAuthUpgradeSocket = null;
    // return true;
  }
  return false;
};

// Declare global pendingAuthUpgradeSocket to store socket reference
declare global {
  interface Window {
    pendingAuthUpgradeSocket: WebSocket | null;
  }
}

// Initialize the global variable
if (typeof window !== 'undefined') {
  window.pendingAuthUpgradeSocket = null;
}

export const handleConnectionMessage = (message: ConnectionMessage, rawSocket: WebSocket | null) => {
  console.log('Connection message:', message);

  switch (message.type) {
    case ConnectionMessageType.CONN_AUTH_REQUIRED: {
      console.log('Auth required');
      const token = authStore.currentState.accessToken;
      const msg = websocket.generators.auth(AuthMessageType.AUTH_REQUEST, {
        clientType: ClientType.PLAYER,
        persistentId: getPersistentPlayerId(),
        tokenJwt: token || undefined,
      });

      if (!token) {
        // Set auth pending flag (disabled for marketing-demo)
        // isAuthPending = true;

        // AUTH_UPGRADE disabled for marketing-demo to prevent lag
        // Store socket reference for later upgrade (disabled for marketing-demo)
        // if (typeof window !== 'undefined') {
        //   window.pendingAuthUpgradeSocket = rawSocket;
        // }

        // TODO: Re-enable if needed for authenticated features

        // Set up listener for token availability
        // const authlistener = authStore.addListener((state) => {
        //   if (state.accessToken) {
        //     // Only send upgrade if auth is no longer pending
        //     if (!isAuthPending && window.pendingAuthUpgradeSocket) {
        //       console.log('Token available and auth not pending, sending upgrade');
        //       const upgradeMsg = websocket.generators.auth(AuthMessageType.AUTH_UPGRADE, {
        //         clientType: ClientType.PLAYER,
        //         persistentId: getPersistentPlayerId(),
        //         tokenJwt: state.accessToken,
        //       });
        //       window.pendingAuthUpgradeSocket.send(JSON.stringify(upgradeMsg));
        //       window.pendingAuthUpgradeSocket = null;
        //     }
        //     authStore.removeListener(authlistener);
        //   }
        // });
      }
      // Bypass ready check
      rawSocket?.send(JSON.stringify(msg));
      break;
    }
    case ConnectionMessageType.CONN_FAST_START_SUCCESS: {
      console.log('[FAST_START] Success:', message);
      const payload = message as any;
      setIsReady(true);
      setFastStartInvitationId(payload.invitationId);

      // Store pre-created peer ID and ICE servers so createPeer can skip PEER_GET_ID
      if (payload.peerId) {
        playerConnectionState.updateState({
          ...playerConnectionState.currentState,
          playerPeerId: payload.peerId,
          peerToken: payload.peerToken,
          iceServers: payload.iceServers || undefined,
        });
      }

      profileState.updateState({
        ...profileState.currentState,
        selectedInvitationId: payload.invitationId,
        creating: false,
      });

      joinState.updateState({
        ...joinState.currentState,
        state: 'inQueue',
      });
      break;
    }
    case ConnectionMessageType.CONN_FAST_START_ERROR: {
      const payload = message as any;
      console.error('[FAST_START] Error at stage', payload.stage, ':', payload.error);

      setIsReady(true);
      joinState.updateState({
        ...joinState.currentState,
        state: 'error',
      });
      break;
    }
  }
};
